// extracted by mini-css-extract-plugin
export default {"Bread__text":"Bread__Bread__text--PQFxi"};